import { loadOnce } from '../../app/chunks'
import type { ForwardDialog } from './ForwardDialog'

/** The forward dialog is a chunk of its own, fetched the first time a message is forwarded. */
export const forwardDialogSource = {
  load: (): Promise<typeof ForwardDialog> => import('./ForwardDialog').then((module) => module.ForwardDialog),
}

/** Loads the forward dialog once. After a failure (offline, or an update replaced the chunk) the next forward tries again. */
export const loadForwardDialog = loadOnce(forwardDialogSource)
